/**
 * Shopify ID helpers shared by all adapters.
 */

/**
 * Extract the numeric ID from a Shopify GID or a plain numeric ID.
 *
 * gid://shopify/Product/123            -> 123
 * gid://shopify/Order/123?key=abc      -> 123
 * "123" / 123                          -> 123
 *
 * Returns 0 for null/undefined/non-numeric input.
 */
export function extractNumericId(id: string | number | null | undefined): number {
  if (typeof id === 'number') {
    return Number.isFinite(id) && id > 0 ? Math.trunc(id) : 0;
  }
  if (!id || typeof id !== 'string') return 0;
  const withoutQuery = id.split('?')[0].trim();
  const match = withoutQuery.match(/(?:^|\/)(\d+)$/);
  return match ? parseInt(match[1], 10) : 0;
}

/**
 * Extract the cart token from a Storefront API cart ID.
 *
 * gid://shopify/Cart/Z2NwLXVz...?key=abc -> Z2NwLXVz...
 *
 * This is the value Shopify's Ajax cart uses in the `cart` cookie, and the
 * value the CDN scripts read as `window.analyzify.cart_id`.
 */
export function extractCartToken(cartId: string | null | undefined): string {
  if (!cartId || typeof cartId !== 'string') return '';
  const withoutGid = cartId.replace(/^gid:\/\/shopify\/Cart\//, '');
  return withoutGid.split('?')[0] || '';
}
